import { classNames, SVGIcon, SvgIcon as KendoSvgIcon, SvgIconProps as KendoSvgIconProps } from '@progress/kendo-react-common';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import styles from './SvgIcon.module.scss';

export type SvgIconProps = {
    className?: string,
    icon: IconDefinition,
    position?: 'left' | 'right'
} & KendoSvgIconProps;

export const SvgIcon = ({ className, icon, position }: SvgIconProps) => {
    const svgIcon = useSvgIcon(icon);
    const props = {
        className: classNames(styles.icon, {
            [styles.reverse]: position === 'right'
        }, className),
        iconClass: 'svg-inline--fa fa-1x',
        svgIcon
    };
    return <KendoSvgIcon {...props} />;
};

export const useSvgIcon = (icon?: IconDefinition): SVGIcon | undefined => {
    if (!icon) {
        return undefined;
    }
    const {
        icon: [x, y, a, b, d],
        iconName
    } = icon;
    return {
        content: `<path d="${d}" />`,
        name: iconName,
        viewBox: `0 0 ${x} ${y}`
    };
}